// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__zQTcW","first-part":"classes_first-part__2hEwS"};